import { DeliveryProvider, OrderFulfillmentStatus, OrderMethod } from '../../../../../services/exports/Constants';

export default {
  text: {
    status: {
      [OrderFulfillmentStatus.Rejected]: 'Er du sikker?',
    },
    [OrderMethod.Pickup]: 'Har kunden allerede hentet ordren?',
    [OrderMethod.OnSite]: 'Er bestillingen serveret ved bordet?',
    [OrderMethod.Delivery]: {
      [DeliveryProvider.Standalone]: 'Er ordren allerede leveret?',
      [DeliveryProvider.UberDrive]: 'Har chaufføren allerede hentet ordren?',
      [DeliveryProvider.FirstDelivery]: 'Har chaufføren allerede hentet ordren?',
      [DeliveryProvider.WoltDrive]: 'Har chaufføren allerede hentet ordren?',
    },
  },
  buttons: {
    cancel: 'Nej, annuller',
    confirm: 'Ja',
  },
};
